/* eslint no-unused-vars: 0 */
import React, { Component } from 'react';

export default class FilterSelector extends Component {

    handleClick(category, label, key) {
        if (this.props.handleClick) {
            this.props.handleClick(category, label, key);
        }
    }

    renderAllFilters(className) {
        if (!this.props.filters || !this.props.filters.count()) {
            return '';
        }

        const filters = [];

        this.props.filters.forEach((filter, key) => {
            const selectedClass = filter.get('selected') ? 'selected' : '';

            filters.push(
                <div className={ `${className}__filter ${selectedClass} app__grid__column__three-one`}
                     onClick={ this.handleClick.bind(this, filter.get('id'), filter.get('name'), key) }>
                    <div dangerouslySetInnerHTML={ { __html: filter.get('name') } }></div>
                </div>
            );
        });

        return filters;
    }

    render() {
        const className = this.props.className ? this.props.className : 'app__filter-selector';

        return <div className={ className }>
            { this.renderAllFilters(className) }
        </div>;
    }
}

FilterSelector.propTypes = {
    filters: React.PropTypes.object,
    handleClick: React.PropTypes.func,
};



// WEBPACK FOOTER //
// ./src/components/elements/FilterSelector.jsx